import { z } from 'zod';

export const leaderboardEntryWireSchema = z.object({
  rank: z.number().int().min(1),
  user_id: z.string(),
  username: z.string().nullable(),
  display_name: z.string().nullable(),
  avatar_url: z.string().nullable(),
  count: z.number().int().min(0),
});
export type LeaderboardEntryWire = z.infer<typeof leaderboardEntryWireSchema>;

export const leaderboardResponseWireSchema = z.object({
  category: z.enum(['check_ins', 'reviews']),
  entries: z.array(leaderboardEntryWireSchema),
  current_user: leaderboardEntryWireSchema,
});
export type LeaderboardResponseWire = z.infer<typeof leaderboardResponseWireSchema>;
